<ng-container *transloco="let t">
    <h1 mat-dialog-title class="flex flex-row justify-between">
        QR Code
        <mat-icon class="tis-curser-pointer" (click)="onClose()">clear</mat-icon>
    </h1>
    <div mat-dialog-content style="display: flex; justify-content: center; padding: 15px;">
        <qrcode
            #qrCode
            id="qrCode"
            [qrdata]="qrCodeStr"
            [allowEmptyString]="true"
            [ariaLabel]="'QR Code image with the following content...'"
            [cssClass]="'tis-qr-code'"
            [colorDark]="'#000000ff'"
            [colorLight]="'#ffffffff'"
            [elementType]="'canvas'"
            [errorCorrectionLevel]="'M'"
            [imageSrc]="'./assets/logo/cantrack-logo-with-border.png'"
            [imageHeight]="68"
            [imageWidth]="68"
            [margin]="1"
            [scale]="1"
            [title]="'Supplier QR Code'"
            [width]="300"
            *ngIf="qrCodeStr"
        ></qrcode>
    </div>
    <div mat-dialog-actions>
        <button mat-button type="button" mat-button [mat-dialog-close]="null" class="tis-text-upper tis-btn-primary" cdkFocusInitial>
            {{t('cancel')}}
        </button>
        <button mat-flat-button mat-button class="tis-text-upper tis-btn-filled-primary" (click)="onDownloadQRCode()" [disabled]="downloading">
            {{t('download')}}
            <i class="fas fa-spinner fa-spin" *ngIf="downloading"></i>
        </button>
    </div>
</ng-container>